import { ApiCaller } from '../../utils/api'
import { URLS } from '../../utils/url'
import {Message} from "element-ui";

const state = {
    list_day:[],
    amount:[],
    data_pie_chart_square_categories: {},
    square_category_colors: []
}
const mutations = {
    SET_SQUARE_LIST_DAY( state, payload ){
        let show_day_chart = []
        payload.forEach(e => {
            show_day_chart.push(e+'日')
        })
        state.list_day = show_day_chart
    },
    SET_SQUARE_AMOUNT( state, payload ){
        state.amount = payload
    },
    SET_DATA_PIE_CHART__SQUARE_CATEGORIES( state, payload ){
        state.data_pie_chart_square_categories = payload
    },
    SET_SQUARE_CATEGORY_COLOR( state, payload ){
        state.square_category_colors = payload
    }
}
const actions = {
    async fetchSquarePayments( {state, commit} ){
        const response = await ApiCaller().get(URLS.SQUARE_API_PAYMENTS())
        // List day of month
        let date = new Date();
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        let number_day_of_month = Math.abs(lastDay - firstDay)/ (1000 * 60 * 60 * 24)+1
        let list_day_of_month = Array.from({length: number_day_of_month}, (_, i) => i + 1)
        commit('SET_SQUARE_LIST_DAY', list_day_of_month)
        // List amount
        const reducer = (accumulator, currentValue) => accumulator + currentValue
        let amount_list = []
        let dataFilter = []
        if( response.data == null) {
          return true
        } else if(response.data.status == 'fail'){
            Message.error({
                message: response.data.message
            })
        } else{
            let dataCurrentTime = response.data.data.payments.filter(x => x.created_at >= firstDay.toISOString() && x.created_at <= lastDay.toISOString())
            list_day_of_month.forEach(e => {
                dataFilter = dataCurrentTime.filter(x => new Date(x.created_at).getDate() == e)
                if (dataFilter.length > 0) {
                    amount_list.push(dataFilter.map(e => e.total_money.amount).reduce(reducer))
                } else {
                    amount_list.push("")
                }
            })
        }
        commit('SET_SQUARE_AMOUNT', amount_list)
        commit('SET_DATA_PIE_CHART__SQUARE_CATEGORIES',response.data.data.data_pie_chart_categories)
        commit('SET_SQUARE_CATEGORY_COLOR', response.data.data.category_colors)
    }
}
export default {
    namespaced: true,
    state, mutations, actions
}
